<ng-container *ngIf="group">
  <div class="page-title">Detalhes do grupo - {{ group?.name }}</div>

  <div class="card">
    <p-tabView
      [activeIndex]="selectedTab"
      (activeIndexChange)="tabChanged($event)"
    >
      <p-tabPanel header="Informações">
        <p-fieldset legend="Informações básicas" class="">
          <form [formGroup]="groupForm" class="form-b4a" (submit)="submit()">
            <span class="p-float-label w-full">
              <input
                id="name"
                type="text"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl('name')
                }"
                pInputText
                formControlName="name"
              />
              <label for="name">Nome *</label>
              <ng-container *ngIf="invalidControl('name')">
                <small
                  class="error"
                  *ngIf="groupForm.controls['name'].error?.required"
                  class="invalid-feedback"
                >
                  Obrigatório
                </small>
              </ng-container>
            </span>

            <span class="p-float-label w-full">
              <input
                id="description"
                type="text"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl('description')
                }"
                pInputText
                formControlName="description"
              />
              <label for="description">Descrição</label>
              <ng-container *ngIf="invalidControl('description')">
                <small
                  class="error"
                  *ngIf="groupForm.controls['description'].error?.required"
                  class="invalid-feedback"
                >
                  Obrigatório
                </small>
              </ng-container>
            </span>

            <span class="p-float-label">
              <p-inputNumber
                id="markupMin"
                type="number"
                formControlName="markupMin"
                [maxFractionDigits]="2"
                [minFractionDigits]="2"
                [max]="100"
                [min]="0.1"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl('markupMin')
                }"
              />
              <label for="markupMin">Markup Mínimo</label>
              <ng-container *ngIf="invalidControl('markupMin')">
                <small
                  class="error"
                  *ngIf="groupForm.controls['markupMin'].error?.required"
                  class="invalid-feedback"
                >
                  Obrigatório
                </small>
                <small
                  class="error"
                  *ngIf="groupForm.controls['markupMin'].error?.min"
                  class="invalid-feedback"
                >
                  Valor invalido
                </small>
              </ng-container>
            </span>

            <span class="p-float-label">
              <p-inputNumber
                id="markupWithoutCompetitor"
                type="number"
                formControlName="markupWithoutCompetitor"
                [maxFractionDigits]="2"
                [minFractionDigits]="2"
                [max]="100"
                [min]="0.1"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl(
                    'markupWithoutCompetitor'
                  )
                }"
              />
              <label for="markupWithoutCompetitor"
                >Markup sem Concorrente</label
              >
            </span>

            <span class="p-float-label">
              <p-inputNumber
                id="discountCompetitor"
                type="number"
                suffix="%"
                formControlName="discountCompetitor"
                [maxFractionDigits]="2"
                [minFractionDigits]="2"
                [max]="100"
                [min]="0.1"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl('discountCompetitor')
                }"
              />
              <label for="discountCompetitor">Desconto Concorrente (%)</label>
            </span>

            <span class="p-float-label">
              <p-inputNumber
                id="subscriberDiscountPercentage"
                type="number"
                suffix="%"
                formControlName="subscriberDiscountPercentage"
                [maxFractionDigits]="2"
                [minFractionDigits]="2"
                [max]="100"
                [min]="0.1"
                [ngClass]="{
                  'ng-invalid ng-dirty': invalidControl(
                    'subscriberDiscountPercentage'
                  )
                }"
              />
              <label for="subscriberDiscountPercentage"
                >Desconto Assinante (%)</label
              >
            </span>

            <span class="p-input-checkbox">
              <p-checkbox
                formControlName="dynamicPrecification"
                [binary]="true"
                inputId="dynamicPrecification"
              />
              <label for="dynamicPrecification">Precificação automática</label>
            </span>

            <div class="form-footer">
              <div class="action">
                <p-button
                  type="submit"
                  pRipple
                  label="Salvar"
                  severity="primary"
                />
              </div>
            </div>
          </form>
        </p-fieldset>
      </p-tabPanel>

      <p-tabPanel *ngIf="group">
        <ng-template pTemplate="header">
          <span class="p-tabview-title">
            Produtos
            <ng-containter *ngIf="!groupProducts"
              >&nbsp;<i class="pi pi-spinner pi-spin"></i
            ></ng-containter>
            <ng-container *ngIf="groupProducts">
              ({{ groupProducts?.length || 0 | number: '1.0-0' }})</ng-container
            >
          </span>
        </ng-template>

        <app-table
          [lazy]="false"
          *ngIf="groupProducts"
          [elements]="groupProducts"
          [cols]="productCols"
          modelName="produtos"
          tableTitle=" "
          sortField="name"
          [sortOrder]="-1"
          [defaultRows]="10"
          [addButton]="false"
          [changeColumns]="true"
        />
      </p-tabPanel>

      <p-tabPanel *ngIf="group">
        <ng-template pTemplate="header">
          <span class="p-tabview-title"> Atualizações de preços </span>
        </ng-template>

        <app-table
          pageFunctionName="getPaginatedList"
          [service]="shopProductPriceLogService"
          [cols]="priceLogCols"
          modelName="Atualizações de preços"
          tableTitle=" "
          sortField="createdAt"
          [sortOrder]="1"
          [defaultRows]="10"
          [addButton]="false"
          [changeColumns]="true"
          [fixedFilters]="fixedPriceLogFilters"
          [actionButtons]="logActionButtons"
          (actionButtonClick)="showOrderDocumentModal($event)"
        />
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-container>

<p-dialog
  [(visible)]="showDocumentModal"
  header="Dados da atualização de preço {{
    selectedDocument?.createdAt | date: 'short'
  }}"
  [modal]="true"
  [style]="{ width: '60vw', height: '70vh' }"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
>
  <div class="logDetail">
    <div class="form-b4a" *ngIf="selectedDocument">
      <span class="p-float-label">
        <input pInputText [value]="selectedDocument.productEAN" readonly />
        <label>EAN</label>
      </span>

      <span class="p-float-label col-3">
        <input pInputText [value]="selectedDocument.productName" readonly />
        <label>Nome</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="
            'R$ ' + (selectedDocument.productCostPrice | number: '1.2-2')
          "
          readonly
        />
        <label>Preço de Custo</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="selectedDocument.markupMin | number: '1.2-2'"
          readonly
        />
        <label>Markup Mínimo</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="selectedDocument.markupWithoutCompetitor | number: '1.2-2'"
          readonly
        />
        <label>Markup sem Competidor</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="
            (selectedDocument.discountCompetitor | number: '1.2-2') + ' %'
          "
          readonly
        />
        <label>Desconto do Competidor</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="'R$ ' + (selectedDocument.minViablePrice | number: '1.2-2')"
          readonly
        />
        <label>Preço Mínimo Viável</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="'R$ ' + (selectedDocument.targetPrice | number: '1.2-2')"
          readonly
        />
        <label>Preço Alvo</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="'R$ ' + (selectedDocument.productPrice | number: '1.2-2')"
          readonly
        />
        <label>Preço do Produto</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="
            'R$ ' + (selectedDocument.productSubscriberPrice | number: '1.2-2')
          "
          readonly
        />
        <label>Preço para Assinantes</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          [value]="selectedDocument.statusPrecificacao"
          readonly
        />
        <label>Status de Precificação</label>
      </span>

      <div class="w-full">
        <h3>Competidores e Preços</h3>
        <p-table
          [value]="selectedDocument.competitorsAndPrices || []"
          styleClass=""
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Competidor</th>
              <th>Preço</th>
              <th>Preço oferta</th>
              <th>Link</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.competitorId }}</td>
              <td>{{ item.price | currency: 'BRL' : 'symbol' : '1.2-2' }}</td>
              <td>
                {{ item.offerPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}
              </td>
              <td>
                <a [href]="item.competitorUrl" target="_blank">Abrir</a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4">Nenhum competidor encontrado.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>

<p-toast />
<p-confirmPopup />
